import TnTypography from './TnTypography';

export { TnTypography };
